var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.value)?_c('portal',{attrs:{"to":"sliderDrawer"}},[_c('slider-content',{key:_vm.key,attrs:{"slots":_vm.$slots.lazy || _vm.$slots.default},on:{"input":_vm.input},model:{value:(_vm.visible),callback:function ($$v) {_vm.visible=$$v},expression:"visible"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }